import { render, staticRenderFns, recyclableRender, components } from "./Yi-bezier.vue?vue&type=template&id=858cbb04&scoped=true&"
var renderjs
import script from "./Yi-bezier.vue?vue&type=script&lang=js&"
export * from "./Yi-bezier.vue?vue&type=script&lang=js&"
import style0 from "./Yi-bezier.vue?vue&type=style&index=0&id=858cbb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858cbb04",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/Yi-bezier/Yi-bezier.vue"
export default component.exports